/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarColumnsAxisX: {
  name: 'bar-columns-axis-x';
  data: string;
} = {
  name: 'bar-columns-axis-x',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h2A1.5 1.5 0 0 1 5.5 2v6.5h4V5A1.5 1.5 0 0 1 11 3.5h2A1.5 1.5 0 0 1 14.5 5v9.5h.5a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5V2Zm9 7.5h-4v5h4v-5Zm-5-.5V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v12.5h3V9Zm9 5.5V5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v9.5h3Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
